/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb, Form, Input, Button, Upload, Row, Col, Select,
} from 'antd';
import Text from 'antd/lib/typography/Text'; 

import { useTranslation } from 'react-i18next';
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';
// import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import useCreateFirmwares from './useCreateFirmwares';
import styles from './CreateFirmwares.module.less';

const iconProps = {
  className: 'anticon',
  style: { fontSize: 21, minWidth: 'auto' },
};

const progressBarUpload = {
  strokeColor: {
    '0%': '#108ee9',
    '100%': '#87d068',
  },
  strokeWidth: 3,
  format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
};

const { Dragger } = Upload;

function CreateFirmwares({ ...props }) {

  const { t } = useTranslation();
  const {
    onFinishFailed, onFinish,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditDevice,
    fileRequest,
    changeFile, 
    businessData,
    loadingSave
  } = useCreateFirmwares();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>
            <Link to="/dispositivos/administrar/firmware">{t('menu_items.main.firmwares')}</Link>
          </Breadcrumb.Item>
          {(idToEdit)
            ? (
              <>
                <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.devices_edit')}</Breadcrumb.Item>
                <Breadcrumb.Item className={styles.breadcrumb}>{idToEdit}</Breadcrumb.Item>
              </>
            )
            : <Breadcrumb.Item className={styles.breadcrumb}>{t('views.create_firmwares.new_firmware')}</Breadcrumb.Item>}
        </Breadcrumb>

         {/* Primera fila */}
 
        <Form
          name="CreateDevice"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 22 }}
          className={styles.totalForm}
          layout="vertical"
          initialValues={{
            ...dataForm, remenber: true,
            // remember: true, name: 'jhon', client: 'example', state: 'normal',
          }}
          values={{ segment: 'jhon', version: 'example' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        > 

          <Row gutter={16}> 
              <Col span={24}>
                <div> 
                    <h2 style={{marginBottom:0}}>{(idToEdit)?t('menu_items.main.devices_edit'):t('views.create_firmwares.new_firmware')}</h2> 
                </div>
              </Col>
          </Row> 

          <Row gutter={16} style={{marginTop:15}}>  

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  className={styles.label}
                  label={t('views.create_firmwares.form.mac')}
                  name="segment"
                  rules={[
                    { required: true, message: t('views.create_firmwares.form.mac_message') },
                    { type: 'string', max: 16, message: t('views.create_firmwares.form.mac_message_max') },
                  ]}
                >
                  <Input className={styles.input} placeholder={t('views.create_firmwares.form.mac_place_holder')} disabled={idToEdit}/>
                </Form.Item>
              </Col> 

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  className={styles.label}
                  label={t('views.create_firmwares.form.client')}
                  name="version"
                  rules={[{ required: true, message: t('views.create_firmwares.form.client_message') }]}
                >
                  <Input className={styles.input} placeholder={t('views.create_firmwares.form.client_place_holder')} disabled={idToEdit}/>
                </Form.Item>
              </Col> 

              <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 12,order: 1, }} xl={{span: 12,order: 1, }}>
                  <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.business_line')}
                    name="busines_id"//business_type
                    rules={[
                      {
                        required: true,
                        message: t('forms.users.placeholders.business_line'),
                      },
                    ]}
                  >
                    <Select
                      style={{ width: '100%' }}
                      disabled={idToEdit}
                      placeholder={t('forms.users.placeholders.business_line')} 
                      options={businessData} 
                    /> 
                  </Form.Item>
              </Col>

              <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 12,order: 1, }} xl={{span: 12,order: 1, }}>
                <Form.Item
                  className={styles.label}
                  label={t('views.create_firmwares.form.fw_url')}
                  name="fw_url"
                  rules={[{ required: true, message: t('views.create_firmwares.form.client_message') }]}
                // eslint-disable-next-line react/jsx-no-comment-textnodes
                > 
                  <Dragger
                    beforeUpload={() => true}
                    customRequest={fileRequest}
                    onChange={changeFile}
                    multiple={false}
                    maxCount={1}
                    progress={progressBarUpload}
                  >
                    <FontAwesomeIcon icon={faUpload} {...iconProps} />
                    <p className="ant-upload-text">{t('common.click_or_drag')}</p>
                    <p className="ant-upload-hint">
                      {t('common.uptate_firmware')}
                    </p>
                  </Dragger>
                </Form.Item>
              </Col>


          </Row> 
          
          <Row style={{marginTop:25, justifyContent:'end'}}>
              
              <Button key="back" className='m_l' onClick={() => cancelCreateEditDevice()}>
                <span className={styles.textTag2}>{t('forms.users.buttons.cancel')}</span>
              </Button>

              <Button key="button"  className='m_l' type="primary" loading={loadingSave} htmlType="submit" icon={(!idToEdit) ?<PlusOutlined />:null} >
                 {(!idToEdit) ? t('views.create_firmwares.buttons.create') : t('views.create_firmwares.buttons.update') }
              </Button> 
              
          </Row>
        </Form>
      </div>
 

    </MainLayout>
  );

}

export default withAuth(CreateFirmwares);
